import moment from "moment";
import React from "react";
import { Link, useParams } from "react-router-dom";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";

function generateRandomString(len) {
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < len; i++) text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
}

export default function ClientOrderItem(props) {
  const { recruiterUsername } = useParams();
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;
  const { company } = props;
  let { companyName } = company;
  const orderID = generateRandomString(10);
  let clusterURL;
  let formattedCompanyName = companyName.substring(0, company.companyName.indexOf("(") - 1);
  formattedCompanyName = formattedCompanyName.replaceAll(" ", "-").toLowerCase();
  formattedCompanyName = formattedCompanyName.trim().replace(/\s/g, "-").toLowerCase();

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    clusterURL = `/recruiters/${recruiterUsername}/clients/@${formattedCompanyName}/orders/@${orderID}`;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    clusterURL = `/clients/@${formattedCompanyName}/orders/${orderID}`;
  } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
    clusterURL = `/orders/${orderID}`;
  } else {
    clusterURL = `/recruiters/${recruiterUsername}/employers/${formattedCompanyName}/orders/${orderID}`;
  }

  return (
    <tr className="cursor-pointer bg-white border-b hover:bg-gray-50 text-gray-700">
      <td className="flex items-center px-6 py-4">
        <img className="w-10 h-10 rounded-full" src={company.profileImageURL} alt={company.roleName} />
        <div className="pl-3">
          <div className="text-base font-semibold">
            <Link to={clusterURL}>{company.companyName}</Link>
          </div>
          <div className="font-normal">{company.location}</div>
        </div>
      </td>
      <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
      <td className="px-6 py-4">{`@${formattedCompanyName}`}</td>
      <td className="px-6 py-4">{company.roleName}</td>
      <td className="px-6 py-4">{company.location}</td>
      <td className="px-6 py-4">
        <div className="flex items-center">
          <div className="h-2.5 w-2.5 rounded-full bg-green-500 mr-2" /> Active
        </div>
      </td>
      <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
      <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
    </tr>
  );
}
